import { ExportProps } from 'features/report/report-constants'
import TableRowExport from 'component/Pdf/TableRowExport'
import TableRowCommon from 'component/Table/TableRowCommon'
import TableCustom from 'component/Table/TableCustom'
import _ from 'lodash'
import * as UseStyled from 'features/report/useStyled'
import { dateTimeToView } from 'utils/date.utils'
import { useTranslation } from 'react-i18next'
import { TableHead, TableSortLabel } from '@mui/material'
import moment from 'moment'
import { toBuddhistYear } from 'utils/app.utils'

interface FcComponent {
  page: number
  pageLimit: number
  rowCount: number
  sortBy: string
  sortType: string
  data: any
  onRequestSort: (sortBy: string, sortType: string) => void
  handleChangeRowsPerPage: (val: any) => void
  handleChangePage: (val: any) => void
  componentRef: any
  exportData: any
  filter: any
}

export default function TreatmentRightSsoList(props: FcComponent) {
  const headCells = [
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_SSO.#NO', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_SSO.DATE', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_SSO.NO_RECEIPT', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_SSO.CN', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_SSO.PATIENT_NAME', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_SSO.TREATMENT_RIGHT', align: 'left', class: 'text-nowrap' },
    { id: 'message', disablePadding: false, labelKey: 'REPORT.TABLE.TREATMENT_RIGHT_SSO.OPERATIVE', align: 'left', class: 'text-nowrap' }
  ]

  const renderData = (data: any, no: number, exportData: boolean) => {
    const num = exportData === true ? no + 1 : props.page * props.pageLimit - props.pageLimit + no + 1

    const objRenderData = {
      key: num.toString(),
      id: no.toString(),
      obj: data,
      columns: [
        { option: 'TEXT', align: 'left', label: num },
        { option: 'TEXT', align: 'left', label: dateTimeToView(data.paidDateTime), class: 'text-nowrap' },
        { option: 'TEXT', align: 'left', label: data.billNo, class: 'text-nowrap' },
        { option: 'TEXT', align: 'left', label: data.cnNumber || '-' },
        { option: 'TEXT', align: 'left', label: data.patientFullname },
        { option: 'TEXT', align: 'left', label: data.treatmentRightName || '-' },
        { option: 'TEXT', align: 'left', label: data.operativeName || '-' }
      ]
    }
    return <>{(exportData === true && <TableRowExport {...objRenderData} />) || <TableRowCommon {...objRenderData} />}</>
  }

  return (
    <>
      <UseStyled.ResponsiveReportTable>
        <TableCustom
          page={props.page}
          pageLimit={props.pageLimit}
          sortType={props.sortType}
          sortBy={props.sortBy}
          rowCount={props.rowCount}
          onSort={props.onRequestSort}
          setPageLimit={props.handleChangeRowsPerPage}
          setPage={props.handleChangePage}
          headCells={headCells}
          rowsData={_.map(props.data, (d: any, index: number) => renderData(d, index, false))}
          customScroll
        />
      </UseStyled.ResponsiveReportTable>
      <div id="print-table-container" ref={props.componentRef}>
        <TreatmentRightSsoExport
          filter={props.filter}
          headCells={headCells}
          rowsData={_.map(props.exportData, (d: any, index: number) => renderData(d, index, true))}
        />
      </div>
    </>
  )
}

export function TreatmentRightSsoExport(props: ExportProps) {
  const { t } = useTranslation()
  const head = props.headCells
  const headCells = head.filter((headCell: any) => headCell.id !== 'action')

  const FILTER_TITLES = [
    { key: 'BRANCH', label: 'REPORT.FILTER.BRANCH' },
    { key: 'DATE_START', label: 'REPORT.FILTER.DATE_START' },
    { key: 'DATE_END', label: 'REPORT.FILTER.DATE_END' }
  ]

  const renderValue = (value: any, index: any) => {
    if (index === 1 || index === 2) {
      if (value) return toBuddhistYear(moment(value), 'DD/MM/YYYY')
      return '-'
    }
    return value
  }

  return (
    <>
      <TableHead style={{ fontWeight: 800 }}>{t('REPORT.REPORT_NAME.TREATMENT_RIGHT_SSO')}</TableHead>
      <table>
        <tr>
          {FILTER_TITLES.map((filter, index) => (
            <TableSortLabel key={index}>
              <td className="mr-2" style={{ fontSize: 10, fontWeight: 800 }}>
                {t(filter.label)} :{' '}
              </td>
              <td style={{ fontSize: 10, fontWeight: 500 }}>{renderValue(props.filter[index], index)}</td>
            </TableSortLabel>
          ))}
        </tr>
      </table>
      <UseStyled.Styles className="pt-3">
        <table style={{ tableLayout: 'fixed', borderCollapse: 'collapse', minWidth: '100%', maxWidth: '100%' }}>
          <thead>
            <tr>
              {_.map(headCells, (val: any) => (
                <td style={{ textAlign: val.align, fontSize: 10, fontWeight: 500 }}> {t(val.labelKey)}</td>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.rowsData}
            {!props.rowsData.length && (
              <td colSpan={headCells.length} style={{ fontSize: 10 }}>
                {t('REPORT.TITLE.NO_DATA')}
              </td>
            )}
          </tbody>
        </table>
      </UseStyled.Styles>
    </>
  )
}
